module.exports = __webpack_public_path__ + "img/banner2.44f556e6.jpg";